import { render, staticRenderFns } from "./CoursewareRootContent.vue?vue&type=template&id=952306ec&scoped=true&"
import script from "./CoursewareRootContent.vue?vue&type=script&lang=js&"
export * from "./CoursewareRootContent.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareRootContent.vue?vue&type=style&index=0&id=952306ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952306ec",
  null
  
)

export default component.exports